const BYBIT_APY_PERCENTAGE = 12
const DERIBIT_APY_PERCENTAGE = 12
// APY + 10% boost
export const TON_APY_PERCENTAGE = 22
export const HYPERLIQUID_APY_PERCENTAGE = 12

export const CEFI_APY_PERCENTAGE = Math.max(BYBIT_APY_PERCENTAGE, DERIBIT_APY_PERCENTAGE, HYPERLIQUID_APY_PERCENTAGE)
